import { Navigate, Route, Routes } from 'react-router-dom';
import AlumniConnect from 'src/pages/AlumniConnect';
import LiveSession from 'src/pages/LiveSession';

const AlumniConnectRoutes = () => {
	return (
		<Routes>
			<Route path="/alumni/sessions" element={<AlumniConnect />} />
			<Route path="/hosts/sessions/live/:sessionId" element={<LiveSession />} />
			<Route path="*" element={<Navigate to="/alumni/sessions" />} />
		</Routes>
	);
};

export default AlumniConnectRoutes;
